import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TimerComponent, TimerState } from '@app/shared/components/timer/timer.component';
import { TicketOperationStatus } from '@app/shared/models/enums/ticket-operation-status.enum';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-activity',
    templateUrl: './activity.component.html',
    styleUrls: ['./activity.component.scss']
})
export class ActivityComponent implements OnInit {
    @ViewChild(TimerComponent, {static: false}) timer: TimerComponent;

    @Input() activity: any;
    @Input() showDetails = false;
    @Input() canEdit = false;
    @Input() canDelete = false;
    @Input() canSelect = true;
    @Input() finished = false;
    @Input() showActions = false;

    @Output() click = new EventEmitter<any>();
    @Output() edit = new EventEmitter<any>();
    @Output() delete = new EventEmitter<any>();
    @Output() timerStart = new EventEmitter<any>();
    @Output() timerPause = new EventEmitter<any>();
    @Output() timerStop = new EventEmitter<any>();
    @Output() revisionInfoClick = new EventEmitter<any>();

    constructor(private translate: TranslateService) {
    }

    ngOnInit() {
    }

    onClick(event: any) {
        event.preventDefault();
        event.stopPropagation();

        if (this.canSelect) {
            this.click.emit(this.activity);
        }
    }

    onEditClick(event: any) {
        event.preventDefault();
        event.stopPropagation();
        this.edit.emit(this.activity);
    }

    onDeleteClick(event: any) {
        event.preventDefault();
        event.stopPropagation();
        this.delete.emit(this.activity);
    }

    get assigned() {
        const role = this.activity.assignedRole;
        const subtitle = this.translate.instant(
            `admin.toolMaintenancePlans.activities.modal.${role.isOob ? 'implicitRole' : 'personalizedRole'}`
        );

        return {
            icon: "fa fa-user",
            title: role.name,
            subtitle: subtitle
        };
    }

    get nrTasks() {
        return this.activity.nrOfTasks || 0;
    }

    get timerState() {
        if (this.activity?.status) {
            switch (this.activity?.status) {
                case TicketOperationStatus.IN_PROGRESS:
                    return TimerState.START;
                case TicketOperationStatus.ON_HOLD:
                case TicketOperationStatus.RESOLVED:
                    return TimerState.PAUSE;
                default:
                    return TimerState.STOP;
            }
        }
        return TimerState.STOP;
    }

    onHold = () => this.activity?.status === TicketOperationStatus.ON_HOLD;

    onTimerStart() {
        this.timerStart.emit();
    }

    onTimerPause() {
        this.timerPause.emit();
    }

    onTimerStop() {
        this.timerStop.emit();
    }

    pauseTimer() {
        this.timer.pauseTimer();
    }

    onRevisionInfoClick() {
        this.revisionInfoClick.emit();
    }
}
